import { parsePhoneNumberFromString } from "libphonenumber-js/mobile";

import type { PhoneNumber } from "libphonenumber-js/mobile";

/**
 * 入力された電話番号を解析する。
 *
 * 国番号なしの入力は日本の番号として解釈する。
 * SMS で認証コードを送るため、実在する携帯電話番号のときだけ返し、
 * 固定電話・IP電話(050)・存在しない番号は null を返す。
 *
 * 判定は libphonenumber-js に任せる。番号帯の追加に追従でき、日本以外の
 * 番号にも同じ厳しさを適用できるため。metadata は mobile を使う
 * (min には回線種別が入っておらず getType() が使えない)。
 *
 * 注意: 北米のように番号計画上そもそも携帯と固定を区別しない国がある。
 * そうした国の固定電話は弾けない。
 */
export const parseMobilePhoneNumber = (input: string): PhoneNumber | null => {
  const parsed = parsePhoneNumberFromString(input, "JP");
  if (parsed === undefined || !parsed.isValid()) {
    return null;
  }
  if (parsed.getType() !== "MOBILE") {
    return null;
  }
  return parsed;
};

/**
 * 電話番号を表示用に整える。
 * 日本の番号は国内表記(090-1234-5678)、それ以外は国際表記(+1 415 555 2671)。
 * formatNational は国ごとの国内表記になるため、日本以外には使わない。
 */
export const formatPhoneNumber = (phoneNumber: PhoneNumber): string => {
  return phoneNumber.country === "JP"
    ? phoneNumber.formatNational()
    : phoneNumber.formatInternational();
};
